import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {
    Options,
    setOptions,
    overrideComponent,
    StudentPersonalInfoViewModel,
    setViewModel,
    Locale,
} from '@sheerid/jslib';
import App from './App';

import { defaultOptions } from './programOptions';
import { addConfirmEmailValidator, addMajorValidator } from './lib/validators/validators';
import { getQueryParamsByName } from './lib/utils/browser';
import { AllowedCountries } from './lib/types/types';

import { StepStudentPersonalInfoComponent } from './components/Steps/StepStudentPersonalInfoComponent';
import { StepSuccessComponent } from './components/Steps/StepSuccessComponent';
import { StepErrorComponent } from './components/Steps/StepErrorComponent';
import { StepDocUploadComponent } from './components/Steps/StepDocUploadComponent';

setOptions(defaultOptions as Options);
addConfirmEmailValidator();
addMajorValidator();

// @ts-ignore - These components are wrapped with intl
overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent);
// @ts-ignore - These components are wrapped with intl
overrideComponent('StepSuccessComponent', StepSuccessComponent);
// @ts-ignore - These components are wrapped with intl
overrideComponent('StepDocUploadComponent', StepDocUploadComponent);
// @ts-ignore - These components are wrapped with intl
overrideComponent('StepErrorComponent', StepErrorComponent);

const viewModel: StudentPersonalInfoViewModel = {
    email: '',
    birthDate: '',
    firstName: '',
    lastName: '',
    organization: { id: 0, name: '' },
    countryChoice: { value: getQueryParamsByName('country') as AllowedCountries, label: '' },
    localeChoice: { value: getQueryParamsByName('locale') as Locale, label: undefined },
    metadata: {
        type: getQueryParamsByName('type') || '',
        'confirm-email': '',
        'course-type': '',
        'desktop-year': '',
        country: getQueryParamsByName('country') ? getQueryParamsByName('country') : 'US',
        locale: getQueryParamsByName('locale') ? getQueryParamsByName('locale') : 'en-US',
    },
};

setViewModel(viewModel);

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
